export default __webpack_public_path__ + "static/media/33.ba896fc0.png";